/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_Li1_LabelInputs */

const tr_mesafeli_s20_li1_label = /** @type {(inputs: Mesafeli_S20_Li1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Müşteriler için:`)
};

const en_mesafeli_s20_li1_label = /** @type {(inputs: Mesafeli_S20_Li1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Consumer Customers:`)
};

const de_mesafeli_s20_li1_label = /** @type {(inputs: Mesafeli_S20_Li1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Verbraucherkunden:`)
};

const ru_mesafeli_s20_li1_label = /** @type {(inputs: Mesafeli_S20_Li1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для Клиентов-потребителей:`)
};

/**
* | output |
* | --- |
* | "For Consumer Customers:" |
*
* @param {Mesafeli_S20_Li1_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_li1_label = /** @type {((inputs?: Mesafeli_S20_Li1_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_Li1_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_li1_label(inputs)
	if (locale === "de") return de_mesafeli_s20_li1_label(inputs)
	if (locale === "ru") return ru_mesafeli_s20_li1_label(inputs)
	return tr_mesafeli_s20_li1_label(inputs)
});